import {
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance,
} from '../../../../../screens/common/ProjectView.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  weightt34o7llf2uyq as weight,
  align1ejncrrer3meh as align,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_dangerButtonciwpmvl7jmt2 as get_dangerButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
  WarningButtonSemantice48d7oqt0xse as WarningButtonSemantic,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme,
  get_warningTextButton13ztryiioyzkv as get_warningTextButton,
} from '../../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  voidItemAction20crlyymuzk79 as voidItemAction,
  approveSelected1hdkbv3ottf9j as approveSelected,
  denySelected4xcqjhjwclhe as denySelected,
  voidChangeItem1umkby3su12s1 as voidChangeItem,
} from '../approval.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  withWritedlio9p0oewet as withWrite,
  toggle2o6h9frvgo8sq as toggle,
} from '../../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  asyncz02dsa2nb2zt as async,
} from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
  space2ppi73m2qk1br as space,
} from '../../../../space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  divkhq3vjih9fcw as div,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
} from '../../../../../theming/Titles.mjs';
import {
  get_section1qyzr1npzel2z as get_section,
  SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance,
  get_lightSection4cpu8okr0w14 as get_lightSection,
} from '../../../../../theming/sections.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  Action1a4ymn5nx79hk as Action,
} from '../../../../../../utils/utils.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../../nav/AppDimensions.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../../sdk/UserSession.mjs';
import {
  isUnread3o34h317z0nzb as isUnread,
  isUnread2u0ehyt0ioouz as isUnread_0,
  markAsRead30n3njkh9wkat as markAsRead,
} from '../../../../../../extensions/HasReadBy.ext.mjs';
import {
  unreadIconVisibley9o01zmxr3gz as unreadIconVisible,
  actionIcon360epyywhabwj as actionIcon,
  infoBubblebw7xb14ivkdr as infoBubble,
} from '../../../../iconShortcuts.mjs';
import {
  get_cancelled2lvhzg5ousqkd as get_cancelled,
  ChangeStatus_PendingApproval_getInstance38hxy51hg7vly as ChangeStatus_PendingApproval_getInstance,
  ChangeItemReadReceipts_instance2jo5uerda8tke as ChangeItemReadReceipts_instance,
} from '../data.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAndDelayMarkAsReadAction7idih42oelvd as expandAndDelayMarkAsReadAction,
} from '../../../../expansion.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  get_pending3bzoyvzwzq8kn as get_pending,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { renderPriceChangegxsbuhvani39 as renderPriceChange } from '../../../../priceChanges.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../../theming/AppColors.mjs';
import {
  colored3y8uibz1hk46 as colored,
  ForegroundSemantic2og103ajpnjfv as ForegroundSemantic,
} from '../../../../../theming/colorManagement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { contains3hkd7li7hrfjb as contains } from '../../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { renderChangeRequestItemDetails14bsvrbn30hjl as renderChangeRequestItemDetails } from './renderIndividualDetails.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../../theming/separators.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  awaitqeg6zusi9ora as await_0,
  await1kke5zj2piplv as await_1,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { get_linked25zbblktmzgbh as get_linked } from '../../../../../../icons.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  chunked1umgsyuj0x9u1 as chunked,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../../utils/JumpTo.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from '../../../../../dialogs/GenericConfirmationDialog.mjs';
import {
  minus165a8u1e0x1lu as minus,
  plus1ogy4liedzq5j as plus,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ColumnWeightsClass;
function ColumnWeights() {
  if (ColumnWeightsClass === VOID) {
    class $ {
      constructor(lens) {
        this.fha_1 = lens.equals(ProjectLens_Customer_getInstance()) ? 3.5 : 4.0;
        this.gha_1 = 1.0;
        this.hha_1 = lens.equals(ProjectLens_Customer_getInstance()) ? 0.5 : 1.0;
        this.iha_1 = 1.5;
        this.jha_1 = lens.equals(ProjectLens_Customer_getInstance()) ? 2.0 : 2.5;
        this.kha_1 = 1.3;
        this.lha_1 = 1.5;
        this.mha_1 = 1.5;
        this.nha_1 = get_rem(0.5);
        this.oha_1 = get_rem_0(2);
      }
    }
    initMetadataForClass($, 'ColumnWeights');
    ColumnWeightsClass = $;
  }
  return ColumnWeightsClass;
}
function voidButton(_this__u8e3s4, item) {
  var tmp = get_atEnd(_this__u8e3s4);
  var tmp_0 = _this__u8e3s4.ibb(_this__u8e3s4.ibb(tmp, shownWhen(_this__u8e3s4, VOID, voidButton$lambda)), get_dangerButton(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Void');
  view.mbg(voidItemAction(view, voidButton$slambda_0(item)));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp_0, view);
}
function renderPendingItems(_this__u8e3s4, changeOrders, changeItems, voiding, lens) {
  var weights = new (ColumnWeights())(lens);
  // Inline function 'kotlin.collections.setOf' call
  var tmp$ret$0 = emptySet();
  var selectedItems = Signal().fak(tmp$ret$0);
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(selectedItems).p1() === $this$remember.baj(changeItems).p1());
  var allSelected = withWrite(tmp, renderPendingItems$slambda_0(selectedItems, changeItems));
  var labelValue = remember(VOID, VOID, VOID, ($this$remember) => {
    var pending = $this$remember.baj(changeItems);
    var tmp;
    if ($this$remember.baj(selectedItems).p1() === pending.p1()) {
      tmp = ' All';
    } else if ($this$remember.baj(selectedItems).p1() > 1 && $this$remember.baj(selectedItems).p1() < pending.p1()) {
      tmp = ' (' + $this$remember.baj(selectedItems).p1() + ')';
    } else {
      tmp = '';
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  launch(view, VOID, VOID, renderPendingItems$slambda_2(changeOrders, view));
  launch(view, VOID, VOID, renderPendingItems$slambda_4(changeOrders));
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp_0 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_1;
  var tmp_2 = null;
  if (!((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null)) {
    tmp_1 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_1 = Companion_getInstance();
  }
  var tmp_3 = view_0.ibb(tmp_1, indented(view_0, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  body(view_1, 'Work Items');
  view_1.bbn(div(view_1.kba().hb0_1, 2));
  var tmp_4 = view_1.ibb(view_1.ibb(sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2.5)), get_section(view_1)), get_unpadded(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(false);
  view_2.zb8(weights.nha_1);
  if (lens.equals(ProjectLens_Customer_getInstance())) {
    space(view_2, weights.oha_1);
    view_2.bbn(get_px(0));
  }
  var tmp_5 = view_2.ibb(weight(view_2, weights.fha_1), get_centered(view_2));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.xbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Space())(view_3.pc(), 0.15);
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_3.fbb(p_4, view_4);
  bodyBold(view_3, 'Work Item');
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_5, view_3);
  view_2.jbb(weight(view_2, weights.hha_1), renderPendingItems$_anonymous_$_anonymous_$_anonymous_$header_q4anrd(view_2, 'ID'));
  view_2.jbb(weight(view_2, weights.iha_1), renderPendingItems$_anonymous_$_anonymous_$_anonymous_$header_q4anrd(view_2, 'Submitted'));
  view_2.jbb(weight(view_2, weights.jha_1), renderPendingItems$_anonymous_$_anonymous_$_anonymous_$header_q4anrd(view_2, 'Status'));
  view_2.jbb(weight(view_2, weights.kha_1), renderPendingItems$_anonymous_$_anonymous_$_anonymous_$header_q4anrd(view_2, 'Original'));
  view_2.jbb(weight(view_2, weights.lha_1), renderPendingItems$_anonymous_$_anonymous_$_anonymous_$header_q4anrd(view_2, 'Total'));
  view_2.jbb(weight(view_2, weights.mha_1), renderPendingItems$_anonymous_$_anonymous_$_anonymous_$header_q4anrd(view_2, 'Date'));
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_4, view_2);
  var tmp_6 = view_1.ibb(shownWhen(view_1, VOID, ($this$shownWhen) => lens.xgj() || $this$shownWhen.baj(voiding)), sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(2)));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_5 = view_1.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
  view_1.ebb(p_5, view_5);
  view_5.xbm(false);
  shownDefaultFalse(view_5, ($this$shownDefaultFalse) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownDefaultFalse.baj(changeItems).i1();
  });
  var tmp_7 = get_centered(view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Checkbox())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.xah(view_6.cbk_1, allSelected);
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_7, view_6);
  view_5.jbb(view_5.ibb(get_centered(view_5), get_expanding(view_5)), bodyBold(view_5, 'Select All'));
  view_1.fbb(p_5, view_5);
  view_1.jbb(tmp_6, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_7 = view_1.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
  view_1.ebb(p_7, view_7);
  view_7.xbm(true);
  view_7.zb8(get_px(0));
  var expandedMap = HashMap().n8();
  forEach(view_7, changeItems, ($this$forEach, item) => {
    var tmp0 = expandedMap;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = item.h40();
    var value = tmp0.p3(key);
    var tmp;
    if (value == null) {
      var answer = Signal().fak(false);
      tmp0.s3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var itemExpanded = tmp;
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEach.pc());
    var tmp0_elvis_lhs = $this$forEach.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
    $this$forEach.ebb(p, view);
    view.xbm(true);
    view.zb8(get_px(0));
    var tmp_0 = sizeConstraints(view, VOID, VOID, get_rem(2.5));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(weights.nha_1);
    var contents = (_this__u8e3s4) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())(_this__u8e3s4.pc());
      var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
      var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
      _this__u8e3s4.ebb(p, view);
      view.xbm(false);
      view.zb8(weights.nha_1);
      var tmp = weight(view, weights.fha_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.xbm(false);
      view_0.zb8(get_AppDimensions().mg2_1);
      get_centered(view_0);
      unreadIconVisible(view_0, ($this$unreadIconVisible) => isUnread(item.t91(), $this$unreadIconVisible.baj(get_session()).efv_1));
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
      Companion_getInstance();
      var tmp_0 = get_centered(view_0);
      view_0.jbb(tmp_0, expandIcon(view_0, itemExpanded, ($this$expandIcon) => {
        $this$expandIcon.xb8(!get_cancelled(item));
        return Unit_instance;
      }));
      if (lens.xgj()) {
        var tmp_1 = get_centered(view_0);
        view_0.jbb(tmp_1, actionIcon(view_0, VOID, renderPendingItems$lambda$lambda$lambda));
      }
      view_0.jbb(get_centered(view_0), body(view_0, item.ngp_1));
      view_0.jbb(get_centered(view_0), smallBody(view_0, item.z94().e95_1));
      view.fbb(p_0, view_0);
      view.jbb(tmp, view_0);
      var tmp_2 = view.ibb(weight(view, weights.hha_1), get_centered(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_1 = view.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
      view.ebb(p_1, view_1);
      view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
      view_1.bbs(Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var value = item.g26();
      var tmp_3 = view_1.tb5_1;
      var tmp_4;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(value) === 0) {
        tmp_4 = '\xA0';
      } else {
        tmp_4 = value;
      }
      tmp_3.fbu(tmp_4);
      view.fbb(p_1, view_1);
      view.jbb(tmp_2, view_1);
      var tmp_5 = weight(view, weights.iha_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Frame())(view.pc());
      var tmp0_elvis_lhs_2 = view.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
      view.ebb(p_2, view_2);
      var tmp_6 = get_centered(view_2);
      view_2.jbb(tmp_6, renderPriceChange(view_2, VOID, ($this$renderPriceChange) => {
        var tmp = item.u94();
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }));
      view.fbb(p_2, view_2);
      view.jbb(tmp_5, view_2);
      var tmp_7 = view.ibb(view.ibb(weight(view, weights.jha_1), get_centered(view)), colored(view, AppColors_getInstance().cfz_1.yg9_1));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_3 = view.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
      view.ebb(p_3, view_3);
      view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
      view_3.bbs(Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var tmp_8 = view_3.tb5_1;
      var tmp_9;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('Pending') === 0) {
        tmp_9 = '\xA0';
      } else {
        tmp_9 = 'Pending';
      }
      tmp_8.fbu(tmp_9);
      view.fbb(p_3, view_3);
      view.jbb(tmp_7, view_3);
      var tmp_10 = view.ibb(weight(view, weights.kha_1), get_centered(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_4 = view.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
      view.ebb(p_4, view_4);
      view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
      view_4.bbs(Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var value_0 = MonetaryValue__toString_impl_xslc77(item.ogp_1);
      var tmp_11 = view_4.tb5_1;
      var tmp_12;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(value_0) === 0) {
        tmp_12 = '\xA0';
      } else {
        tmp_12 = value_0;
      }
      tmp_11.fbu(tmp_12);
      view.fbb(p_4, view_4);
      view.jbb(tmp_10, view_4);
      var tmp_13 = view.ibb(weight(view, weights.lha_1), get_centered(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_5 = view.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
      view.ebb(p_5, view_5);
      view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
      view_5.bbs(Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
      var value_1 = MonetaryValue__toString_impl_xslc77(item.rh7());
      var tmp_14 = view_5.tb5_1;
      var tmp_15;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(value_1) === 0) {
        tmp_15 = '\xA0';
      } else {
        tmp_15 = value_1;
      }
      tmp_14.fbu(tmp_15);
      view.fbb(p_5, view_5);
      view.jbb(tmp_13, view_5);
      var tmp_16 = view.ibb(weight(view, weights.mha_1), get_centered(view));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_6 = view.cbb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
      view.ebb(p_6, view_6);
      view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance()));
      view_6.bbs(Align_Center_getInstance());
      var tmp_17 = KMutableProperty0();
      var tmp_18 = TextView$_get_content_$ref_4pzcwl(view_6);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb(view_6));
      reactiveScope(view_6, ($this$reactiveScope) => {
        var id = item.q94();
        // Inline function 'kotlin.collections.find' call
        var tmp0 = $this$reactiveScope.baj(changeOrders);
        var tmp$ret$59;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.q57_1.equals(id)) {
              tmp$ret$59 = element;
              break $l$block;
            }
          }
          tmp$ret$59 = null;
        }
        var tmp0_safe_receiver = tmp$ret$59;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v57_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : format(tmp1_safe_receiver, Formats_getInstance().j8z_1);
        var tmp$ret$61 = tmp2_elvis_lhs == null ? 'ERR' : tmp2_elvis_lhs;
        this_0.set(tmp$ret$61);
        return Unit_instance;
      });
      view.fbb(p_6, view_6);
      view.jbb(tmp_16, view_6);
      _this__u8e3s4.fbb(p, view);
      return view;
    };
    var tmp_1 = get_centered(view_0);
    var tmp_2 = view_0.ibb(tmp_1, shownWhen(view_0, VOID, ($this$shownWhen) => lens.xgj() || $this$shownWhen.baj(voiding)));
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Checkbox())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    var tmp_3 = KMutableProperty0();
    var tmp_4 = Checkbox$_get_visible_$ref_b1kh59(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('visible', 0, tmp_3, tmp_4, Checkbox$_set_visible_$ref_j8tp6n(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$72 = $this$reactiveScope.baj(voiding) || !item.s94();
      this_0.set(tmp$ret$72);
      return Unit_instance;
    });
    view_1.xah(view_1.cbk_1, contains(selectedItems, item.h40()));
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_2, view_1);
    if (get_cancelled(item)) {
      view_0.jbb(get_expanding(view_0), contents(view_0));
      var tmp_5 = get_AppScope();
      launch(tmp_5, VOID, VOID, renderPendingItems$lambda$slambda_0(item));
    } else {
      var tmp_6 = view_0.ibb(get_expanding(view_0), get_unpadded(view_0));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.ebb(p_2, view_2);
      contents(view_2);
      view_2.mbg(Action('Expand and mark as read', VOID, renderPendingItems$lambda$slambda_2(itemExpanded, item)));
      view_0.fbb(p_2, view_2);
      view_0.jbb(tmp_6, view_2);
    }
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
    view.jbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(itemExpanded)), renderChangeRequestItemDetails(view, item));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    view_3.xbm(false);
    if (lens.equals(ProjectLens_Customer_getInstance())) {
      space(view_3, weights.oha_1);
    }
    view_3.jbb(get_expanding(view_3), greySeparator(view_3));
    view.fbb(p_3, view_3);
    $this$forEach.fbb(p, view);
    return Unit_instance;
  });
  view_1.fbb(p_7, view_7);
  var tmp_8 = get_atEnd(view_1);
  var tmp_9 = view_1.ibb(tmp_8, shownWhen(view_1, VOID, ($this$shownWhen) => lens.xgj() || $this$shownWhen.baj(voiding)));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_8 = view_1.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
  view_1.ebb(p_8, view_8);
  view_8.xbm(false);
  if (lens.xgj()) {
    var tmp_10 = get_primaryButton(view_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Button())(view_8.pc());
    var tmp0_elvis_lhs_9 = view_8.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
    view_8.ebb(p_9, view_9);
    var tmp_11 = KMutableProperty0();
    var tmp_12 = Button$_get_enabled_$ref_61t7nx(view_9);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('enabled', 0, tmp_11, tmp_12, Button$_set_enabled_$ref_o8kynz(view_9));
    reactiveScope(view_9, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$97 = !$this$reactiveScope.baj(selectedItems).i1();
      this_0.set(tmp$ret$97);
      return Unit_instance;
    });
    specCenteredText_0(view_9, ($this$specCenteredText) => 'Approve' + $this$specCenteredText.baj(labelValue));
    view_9.mbg(approveSelected(view_9, renderPendingItems$slambda_6(selectedItems, changeItems)));
    view_8.fbb(p_9, view_9);
    view_8.jbb(tmp_10, view_9);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Button())(view_8.pc());
  var tmp0_elvis_lhs_10 = view_8.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
  view_8.ebb(p_10, view_10);
  dynamicTheme(view_10, ($this$dynamicTheme) => $this$dynamicTheme.baj(voiding) ? DangerButtonSemantic_getInstance() : WarningButtonSemantic());
  var tmp_13 = KMutableProperty0();
  var tmp_14 = Button$_get_enabled_$ref_61t7nx_0(view_10);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('enabled', 0, tmp_13, tmp_14, Button$_set_enabled_$ref_o8kynz_0(view_10));
  reactiveScope(view_10, ($this$reactiveScope) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$103 = !$this$reactiveScope.baj(selectedItems).i1();
    this_1.set(tmp$ret$103);
    return Unit_instance;
  });
  specCenteredText_0(view_10, ($this$specCenteredText) => $this$specCenteredText.baj(voiding) ? 'Void' + $this$specCenteredText.baj(labelValue) : 'Reject' + $this$specCenteredText.baj(labelValue));
  var deny = denySelected(view_10, renderPendingItems$slambda_8(selectedItems, changeItems));
  onClick(view_10, VOID, VOID, renderPendingItems$slambda_10(voiding, selectedItems, changeItems, view_10, deny));
  view_8.fbb(p_10, view_10);
  view_1.fbb(p_8, view_8);
  view_1.jbb(tmp_9, view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (Space())(view_1.pc());
  var tmp0_elvis_lhs_11 = view_1.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_1 : tmp0_elvis_lhs_11;
  view_1.ebb(p_11, view_11);
  view_1.fbb(p_11, view_11);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_3, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
}
function renderPendingChangeOrder(_this__u8e3s4, changeOrder, changeItems, lens) {
  var expanded = Signal().fak(true);
  var pending = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(changeItems);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (get_pending(element)) {
        destination.v(element);
      }
    }
    return destination;
  });
  var pendingLinked = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(pending);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.s94()) {
        destination.v(element);
      }
    }
    return destination;
  });
  var pendingNonLinked = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(pending);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!element.s94()) {
        destination.v(element);
      }
    }
    return destination;
  });
  var allPending = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0 = $this$remember.baj(changeItems);
    var tmp$ret$9;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$9 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (!get_pending(element)) {
          tmp$ret$9 = false;
          break $l$block_0;
        }
      }
      tmp$ret$9 = true;
    }
    return tmp$ret$9;
  });
  var total = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$remember.baj(pending);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp0_elvis_lhs = element.u94();
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
        tmp_0 = Companion_instance.p91(0n);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$11 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$11);
    }
    var tmp$ret$12 = sum;
    return new (MonetaryValue())(tmp$ret$12);
  });
  // Inline function 'kotlin.collections.setOf' call
  var tmp$ret$13 = emptySet();
  var selectedItems = Signal().fak(tmp$ret$13);
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.baj(selectedItems);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(pending);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.s94()) {
        destination.v(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$17 = item.h40();
      destination_0.v(tmp$ret$17);
    }
    return tmp.l3(destination_0);
  });
  var selectedLinkedItems = withWrite(tmp, renderPendingChangeOrder$slambda_0(selectedItems, pending));
  var tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(selectedItems).p1() === $this$remember.baj(pending).p1());
  var allSelected = withWrite(tmp_0, renderPendingChangeOrder$slambda_2(selectedItems, pending));
  var unread = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if (isUnread_0($this$remember.baj(changeOrder), $this$remember.baj(get_session()).efv_1)) {
      tmp = true;
    } else {
      var tmp0 = $this$remember.baj(changeItems);
      var tmp$ret$20;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$20 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (isUnread(element.mgp_1.t91(), $this$remember.baj(get_session()).efv_1)) {
            tmp$ret$20 = true;
            break $l$block_2;
          }
        }
        tmp$ret$20 = false;
      }
      tmp = tmp$ret$20;
    }
    return tmp;
  });
  var weights = new (ColumnWeights())(lens);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  launch(view, VOID, VOID, renderPendingChangeOrder$slambda_4(changeOrder, view, expanded));
  view.zb8(get_px(0));
  var tmp_1 = get_expandButtonTheme(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(expanded) ? SectionSemantic_getInstance() : null);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.zb8(get_AppDimensions().mg2_1);
  get_centered(view_1);
  unreadIconVisible(view_1, ($this$unreadIconVisible) => $this$unreadIconVisible.baj(unread));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance();
  view_1.jbb(get_centered(view_1), expandIcon(view_1, expanded));
  if (lens.xgj()) {
    var tmp_2 = get_centered(view_1);
    view_1.jbb(tmp_2, actionIcon(view_1, VOID, renderPendingChangeOrder$lambda));
  }
  var tmp_3 = get_centered(view_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_0(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_0(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var c = $this$reactiveScope.baj(changeOrder);
    var tmp0_safe_receiver = $this$reactiveScope.baj(changeOrder).v57_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : format(tmp0_safe_receiver, Formats_getInstance().j8z_1);
    var tmp$ret$23 = 'Change #' + c.b58_1 + ': ' + c.s57_1 + ' ' + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
    this_0.set(tmp$ret$23);
    return Unit_instance;
  });
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_3, view_2);
  view_0.fbb(p_1, view_1);
  onClick(view_0, 'Toggle Expanded', VOID, renderPendingChangeOrder$slambda_6(expanded, changeOrder));
  view.fbb(p_0, view_0);
  view.jbb(tmp_1, view_0);
  var tmp_6 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expanded));
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp_7 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  var tmp_8;
  var tmp_9 = null;
  if (!((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null)) {
    tmp_8 = sizeConstraints(view_3, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_8 = Companion_getInstance();
  }
  var tmp_10 = view_3.ibb(tmp_8, indented(view_3, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.xbm(true);
  view_4.zb8(get_px(0));
  space(view_4, get_rem_0(1));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_11 = KMutableProperty0();
  var tmp_12 = TextView$_get_content_$ref_4pzcwl_1(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb_1(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$37 = 'Description: ' + $this$reactiveScope.baj(changeOrder).t57_1;
    this_1.set(tmp$ret$37);
    return Unit_instance;
  });
  view_4.fbb(p_5, view_5);
  space(view_4, get_rem_0(1));
  var tmp_13 = view_4.ibb(view_4.ibb(sizeConstraints(view_4, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2.5)), get_section(view_4)), get_unpadded(view_4));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.ebb(p_6, view_6);
  view_6.xbm(false);
  view_6.zb8(weights.nha_1);
  if (lens.equals(ProjectLens_Customer_getInstance())) {
    var tmp_14 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, weights.oha_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Space())(view_6.pc());
    var tmp0_elvis_lhs_7 = view_6.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
    view_6.ebb(p_7, view_7);
    view_6.fbb(p_7, view_7);
    view_6.jbb(tmp_14, view_7);
  }
  var tmp_15 = view_6.ibb(get_centered(view_6), get_expanding(view_6));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_8 = view_6.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
  view_6.ebb(p_8, view_8);
  view_8.xbm(false);
  view_8.zb8(weights.nha_1);
  var tmp_16 = weight(view_8, weights.fha_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Space())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.ebb(p_9, view_9);
  view_8.fbb(p_9, view_9);
  view_8.jbb(tmp_16, view_9);
  var tmp_17 = view_8.ibb(weight(view_8, weights.gha_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_10 = view_8.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
  view_8.ebb(p_10, view_10);
  view_10.jba(view_10.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_18 = KMutableProperty0();
  var tmp_19 = TextView$_get_visible_$ref_cygc3o(view_10);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('visible', 0, tmp_18, tmp_19, TextView$_set_visible_$ref_rs9jjk(view_10));
  reactiveScope(view_10, ($this$reactiveScope) => {
    var tmp$ret$50 = $this$reactiveScope.baj(changeOrder).x57_1;
    this_2.set(tmp$ret$50);
    return Unit_instance;
  });
  view_10.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_20 = view_10.tb5_1;
  var tmp_21;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('') === 0) {
    tmp_21 = '\xA0';
  } else {
    tmp_21 = '';
  }
  tmp_20.fbu(tmp_21);
  view_8.fbb(p_10, view_10);
  view_8.jbb(tmp_17, view_10);
  var tmp_22 = view_8.ibb(weight(view_8, weights.hha_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_11 = view_8.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_8 : tmp0_elvis_lhs_11;
  view_8.ebb(p_11, view_11);
  view_11.jba(view_11.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_11.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_23 = view_11.tb5_1;
  var tmp_24;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('ID') === 0) {
    tmp_24 = '\xA0';
  } else {
    tmp_24 = 'ID';
  }
  tmp_23.fbu(tmp_24);
  view_8.fbb(p_11, view_11);
  view_8.jbb(tmp_22, view_11);
  var tmp_25 = view_8.ibb(weight(view_8, weights.iha_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_12 = view_8.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_8 : tmp0_elvis_lhs_12;
  view_8.ebb(p_12, view_12);
  view_12.jba(view_12.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_12.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Submitted';
  var tmp_26 = view_12.tb5_1;
  var tmp_27;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_27 = '\xA0';
  } else {
    tmp_27 = value;
  }
  tmp_26.fbu(tmp_27);
  view_8.fbb(p_12, view_12);
  view_8.jbb(tmp_25, view_12);
  var tmp_28 = view_8.ibb(weight(view_8, weights.jha_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_13 = view_8.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_8 : tmp0_elvis_lhs_13;
  view_8.ebb(p_13, view_13);
  view_13.jba(view_13.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_13.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_29 = view_13.tb5_1;
  var tmp_30;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Status') === 0) {
    tmp_30 = '\xA0';
  } else {
    tmp_30 = 'Status';
  }
  tmp_29.fbu(tmp_30);
  view_8.fbb(p_13, view_13);
  view_8.jbb(tmp_28, view_13);
  var tmp_31 = view_8.ibb(weight(view_8, weights.kha_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_14 = view_8.cbb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_8 : tmp0_elvis_lhs_14;
  view_8.ebb(p_14, view_14);
  view_14.jba(view_14.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_14.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = 'Original';
  var tmp_32 = view_14.tb5_1;
  var tmp_33;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_33 = '\xA0';
  } else {
    tmp_33 = value_0;
  }
  tmp_32.fbu(tmp_33);
  view_8.fbb(p_14, view_14);
  view_8.jbb(tmp_31, view_14);
  var tmp_34 = view_8.ibb(weight(view_8, weights.lha_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_15 = view_8.cbb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_8 : tmp0_elvis_lhs_15;
  view_8.ebb(p_15, view_15);
  view_15.jba(view_15.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_15.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_35 = view_15.tb5_1;
  var tmp_36;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Total') === 0) {
    tmp_36 = '\xA0';
  } else {
    tmp_36 = 'Total';
  }
  tmp_35.fbu(tmp_36);
  view_8.fbb(p_15, view_15);
  view_8.jbb(tmp_34, view_15);
  view_6.fbb(p_8, view_8);
  view_6.jbb(tmp_15, view_8);
  view_4.fbb(p_6, view_6);
  view_4.jbb(tmp_13, view_6);
  var pendingRow = (_this__u8e3s4, item) => {
    var itemExpanded = Signal().fak(false);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.xbm(true);
    view.zb8(get_px(0));
    var tmp = sizeConstraints(view, VOID, VOID, get_rem(2.5));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(weights.nha_1);
    var contents = (_this__u8e3s4) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())(_this__u8e3s4.pc());
      var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
      var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
      _this__u8e3s4.ebb(p, view);
      view.xbm(false);
      view.zb8(weights.nha_1);
      var tmp = weight(view, weights.fha_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.xbm(false);
      view_0.zb8(get_AppDimensions().mg2_1);
      var tmp_0 = get_centered(view_0);
      view_0.jbb(tmp_0, expandIcon(view_0, itemExpanded, ($this$expandIcon) => {
        $this$expandIcon.xb8(!get_cancelled(item));
        return Unit_instance;
      }));
      view_0.jbb(get_centered(view_0), body(view_0, item.ngp_1));
      view_0.jbb(get_centered(view_0), smallBody(view_0, 'New'));
      view.fbb(p_0, view_0);
      view.jbb(tmp, view_0);
      var tmp_1 = ($this$tableRow) => item.s94();
      var tmp_2 = ($this$tableRow) => item.w94();
      var tmp_3 = ($this$tableRow) => {
        var tmp = item.u94();
        return tmp == null ? null : new (MonetaryValue())(tmp);
      };
      var tmp_4 = ($this$tableRow) => !$this$tableRow.baj(allPending);
      var tmp_5 = ($this$tableRow) => !$this$tableRow.baj(allPending);
      var tmp_6 = ($this$tableRow) => !$this$tableRow.baj(allPending);
      renderPendingChangeOrder$_anonymous_$_anonymous_$tableRow_3w1ngh(view, weights, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, renderPendingChangeOrder$lambda$lambda$lambda);
      _this__u8e3s4.fbb(p, view);
      return view;
    };
    if (lens.equals(ProjectLens_Customer_getInstance())) {
      var tmp_0 = get_centered(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Checkbox())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.ebb(p_1, view_1);
      view_1.xb8(!item.s94());
      view_1.xah(view_1.cbk_1, contains(selectedItems, item.h40()));
      view_0.fbb(p_1, view_1);
      view_0.jbb(tmp_0, view_1);
    }
    if (get_cancelled(item)) {
      view_0.jbb(get_expanding(view_0), contents(view_0));
      launch(view_0, VOID, VOID, renderPendingChangeOrder$lambda$slambda_0(item));
    } else {
      var tmp_1 = get_expanding(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.ebb(p_2, view_2);
      view_2.eba(get_px(0));
      view_2.zb8(get_px(0));
      contents(view_2);
      view_2.mbg(expandAndDelayMarkAsReadAction(itemExpanded, renderPendingChangeOrder$lambda$slambda_2(item)));
      view_0.fbb(p_2, view_2);
      view_0.jbb(tmp_1, view_2);
    }
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    if (!get_cancelled(item)) {
      var tmp_2 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(itemExpanded));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_3 = view.cbb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
      view.ebb(p_3, view_3);
      view_3.xbm(true);
      renderChangeRequestItemDetails(view_3, item);
      if (lens.equals(ProjectLens_Contractor_getInstance())) {
        voidButton(view_3, item);
      }
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Space())(view_3.pc(), 0.5);
      var tmp0_elvis_lhs_4 = view_3.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
      view_3.ebb(p_4, view_4);
      view_3.fbb(p_4, view_4);
      view.fbb(p_3, view_3);
      view.jbb(tmp_2, view_3);
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_5 = view.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
    view.ebb(p_5, view_5);
    view_5.xbm(false);
    view_5.zb8(weights.nha_1);
    if (lens.equals(ProjectLens_Customer_getInstance())) {
      space(view_5, weights.oha_1);
    }
    view_5.jbb(get_expanding(view_5), greySeparator(view_5));
    view.fbb(p_5, view_5);
    _this__u8e3s4.fbb(p, view);
    return view;
  };
  var tmp_37 = sizeConstraints(view_4, VOID, VOID, get_rem_0(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_16 = view_4.cbb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_4 : tmp0_elvis_lhs_16;
  view_4.ebb(p_16, view_16);
  view_16.xbm(false);
  view_16.zb8(weights.nha_1);
  if (lens.equals(ProjectLens_Customer_getInstance())) {
    var tmp_38 = sizeConstraints(view_16, VOID, VOID, VOID, VOID, VOID, weights.oha_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_17 = new (Space())(view_16.pc());
    var tmp0_elvis_lhs_17 = view_16.cbb_1;
    var p_17 = tmp0_elvis_lhs_17 == null ? view_16 : tmp0_elvis_lhs_17;
    view_16.ebb(p_17, view_17);
    view_16.fbb(p_17, view_17);
    view_16.jbb(tmp_38, view_17);
  }
  var tmp_39 = get_expanding(view_16);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (RowOrCol())(view_16.pc());
  var tmp0_elvis_lhs_18 = view_16.cbb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view_16 : tmp0_elvis_lhs_18;
  view_16.ebb(p_18, view_18);
  view_18.xbm(false);
  view_18.zb8(weights.nha_1);
  view_18.jbb(view_18.ibb(weight(view_18, weights.fha_1), get_centered(view_18)), bodyBold(view_18, 'Proposed Changes'));
  var tmp_40 = renderPendingChangeOrder$lambda_0;
  var tmp_41 = ($this$tableRow) => $this$tableRow.baj(changeOrder).b58_1;
  var tmp_42 = ($this$tableRow) => $this$tableRow.baj(total);
  var tmp_43 = ($this$tableRow) => $this$tableRow.baj(allPending);
  var tmp_44 = ($this$tableRow) => $this$tableRow.baj(allPending);
  var tmp_45 = ($this$tableRow) => $this$tableRow.baj(allPending);
  renderPendingChangeOrder$_anonymous_$_anonymous_$tableRow_3w1ngh(view_18, weights, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, renderPendingChangeOrder$lambda_1);
  view_16.fbb(p_18, view_18);
  view_16.jbb(tmp_39, view_18);
  view_4.fbb(p_16, view_16);
  view_4.jbb(tmp_37, view_16);
  if (lens.equals(ProjectLens_Customer_getInstance())) {
    var tmp_46 = sizeConstraints(view_4, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2.5));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_19 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_19 = view_4.cbb_1;
    var p_19 = tmp0_elvis_lhs_19 == null ? view_4 : tmp0_elvis_lhs_19;
    view_4.ebb(p_19, view_19);
    view_19.xbm(false);
    shownDefaultFalse(view_19, ($this$shownDefaultFalse) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownDefaultFalse.baj(pendingNonLinked).i1();
    });
    var tmp_47 = get_centered(view_19);
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_20 = new (Checkbox())(view_19.pc());
    var tmp0_elvis_lhs_20 = view_19.cbb_1;
    var p_20 = tmp0_elvis_lhs_20 == null ? view_19 : tmp0_elvis_lhs_20;
    view_19.ebb(p_20, view_20);
    view_20.xah(view_20.cbk_1, allSelected);
    view_19.fbb(p_20, view_20);
    view_19.jbb(tmp_47, view_20);
    view_19.jbb(view_19.ibb(get_centered(view_19), get_expanding(view_19)), bodyBold(view_19, 'Select All'));
    view_4.fbb(p_19, view_19);
    view_4.jbb(tmp_46, view_19);
  }
  if (lens.equals(ProjectLens_Customer_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_21 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_21 = view_4.cbb_1;
    var p_21 = tmp0_elvis_lhs_21 == null ? view_4 : tmp0_elvis_lhs_21;
    view_4.ebb(p_21, view_21);
    view_21.xbm(false);
    view_21.zb8(weights.nha_1);
    shownDefaultFalse(view_21, ($this$shownDefaultFalse) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownDefaultFalse.baj(pending).i1();
    });
    space(view_21, weights.oha_1);
    view_21.jbb(get_expanding(view_21), greySeparator(view_21));
    view_4.fbb(p_21, view_21);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_22 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_22 = view_4.cbb_1;
    var p_22 = tmp0_elvis_lhs_22 == null ? view_4 : tmp0_elvis_lhs_22;
    view_4.ebb(p_22, view_22);
    view_22.xbm(false);
    view_22.zb8(weights.nha_1);
    shownDefaultFalse(view_22, ($this$shownDefaultFalse) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !$this$shownDefaultFalse.baj(pendingLinked).i1();
    });
    var tmp_48 = sizeConstraints(view_22, VOID, VOID, VOID, VOID, VOID, weights.oha_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_23 = new (Frame())(view_22.pc());
    var tmp0_elvis_lhs_23 = view_22.cbb_1;
    var p_23 = tmp0_elvis_lhs_23 == null ? view_22 : tmp0_elvis_lhs_23;
    view_22.ebb(p_23, view_23);
    var tmp_49 = align(view_23, Align_Start_getInstance(), Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_24 = new (Checkbox())(view_23.pc());
    var tmp0_elvis_lhs_24 = view_23.cbb_1;
    var p_24 = tmp0_elvis_lhs_24 == null ? view_23 : tmp0_elvis_lhs_24;
    view_23.ebb(p_24, view_24);
    view_24.xah(view_24.cbk_1, selectedLinkedItems);
    view_23.fbb(p_24, view_24);
    view_23.jbb(tmp_49, view_24);
    view_22.fbb(p_23, view_23);
    view_22.jbb(tmp_48, view_23);
    var tmp_50 = view_22.ibb(view_22.ibb(get_lightSection(view_22), sizeConstraints(view_22, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2.5))), get_expanding(view_22));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_25 = new (RowOrCol())(view_22.pc());
    var tmp0_elvis_lhs_25 = view_22.cbb_1;
    var p_25 = tmp0_elvis_lhs_25 == null ? view_22 : tmp0_elvis_lhs_25;
    view_22.ebb(p_25, view_25);
    view_25.xbm(false);
    view_25.zb8(weights.nha_1);
    var tmp_51 = view_25.ibb(weight(view_25, weights.fha_1), get_centered(view_25));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_26 = new (RowOrCol())(view_25.pc());
    var tmp0_elvis_lhs_26 = view_25.cbb_1;
    var p_26 = tmp0_elvis_lhs_26 == null ? view_25 : tmp0_elvis_lhs_26;
    view_25.ebb(p_26, view_26);
    view_26.xbm(false);
    bodyBold(view_26, 'Linked Approval');
    view_26.jbb(get_centered(view_26), infoBubble(view_26, 'Linked items must be approved or rejected together.'));
    view_25.fbb(p_26, view_26);
    view_25.jbb(tmp_51, view_26);
    var tmp_52 = renderPendingChangeOrder$lambda_2;
    var tmp_53 = renderPendingChangeOrder$lambda_3;
    var tmp_54 = ($this$tableRow) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$tableRow.baj(pendingLinked);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.u94();
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$170 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$170);
      }
      var tmp$ret$171 = sum;
      return new (MonetaryValue())(tmp$ret$171);
    };
    var tmp_55 = renderPendingChangeOrder$lambda_4;
    var tmp_56 = renderPendingChangeOrder$lambda_5;
    var tmp_57 = renderPendingChangeOrder$lambda_6;
    renderPendingChangeOrder$_anonymous_$_anonymous_$tableRow_3w1ngh(view_25, weights, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, tmp_57, renderPendingChangeOrder$lambda_7);
    view_22.fbb(p_25, view_25);
    view_22.jbb(tmp_50, view_25);
    view_4.fbb(p_22, view_22);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_27 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_27 = view_4.cbb_1;
    var p_27 = tmp0_elvis_lhs_27 == null ? view_4 : tmp0_elvis_lhs_27;
    view_4.ebb(p_27, view_27);
    view_27.xbm(false);
    view_27.zb8(weights.nha_1);
    shownDefaultFalse(view_27, ($this$shownDefaultFalse) => {
      var tmp0 = $this$shownDefaultFalse.baj(pending);
      var tmp$ret$180;
      $l$block_4: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(tmp0, Collection())) {
          tmp = tmp0.i1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$180 = false;
          break $l$block_4;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.s94()) {
            tmp$ret$180 = true;
            break $l$block_4;
          }
        }
        tmp$ret$180 = false;
      }
      return tmp$ret$180;
    });
    space(view_27, weights.oha_1);
    view_27.jbb(get_expanding(view_27), greySeparator(view_27));
    view_4.fbb(p_27, view_27);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_28 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_28 = view_4.cbb_1;
  var p_28 = tmp0_elvis_lhs_28 == null ? view_4 : tmp0_elvis_lhs_28;
  view_4.ebb(p_28, view_28);
  view_28.xbm(true);
  view_28.zb8(get_px(0));
  forEach(view_28, pendingLinked, ($this$forEach, item) => {
    pendingRow($this$forEach, item);
    return Unit_instance;
  });
  view_4.fbb(p_28, view_28);
  if (lens.equals(ProjectLens_Customer_getInstance())) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_29 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_29 = view_4.cbb_1;
    var p_29 = tmp0_elvis_lhs_29 == null ? view_4 : tmp0_elvis_lhs_29;
    view_4.ebb(p_29, view_29);
    view_29.xbm(false);
    view_29.zb8(weights.nha_1);
    shownDefaultFalse(view_29, ($this$shownDefaultFalse) => {
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this$shownDefaultFalse.baj(pendingNonLinked).i1()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !$this$shownDefaultFalse.baj(pendingLinked).i1();
      } else {
        tmp = false;
      }
      return tmp;
    });
    var tmp_58 = sizeConstraints(view_29, VOID, VOID, VOID, VOID, VOID, weights.oha_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_30 = new (Space())(view_29.pc());
    var tmp0_elvis_lhs_30 = view_29.cbb_1;
    var p_30 = tmp0_elvis_lhs_30 == null ? view_29 : tmp0_elvis_lhs_30;
    view_29.ebb(p_30, view_30);
    view_29.fbb(p_30, view_30);
    view_29.jbb(tmp_58, view_30);
    var tmp_59 = view_29.ibb(view_29.ibb(get_lightSection(view_29), sizeConstraints(view_29, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2.5))), get_expanding(view_29));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_31 = new (RowOrCol())(view_29.pc());
    var tmp0_elvis_lhs_31 = view_29.cbb_1;
    var p_31 = tmp0_elvis_lhs_31 == null ? view_29 : tmp0_elvis_lhs_31;
    view_29.ebb(p_31, view_31);
    view_31.xbm(false);
    view_31.zb8(weights.nha_1);
    view_31.jbb(view_31.ibb(get_centered(view_31), get_expanding(view_31)), bodyBold(view_31, 'Independent Approval'));
    view_29.fbb(p_31, view_31);
    view_29.jbb(tmp_59, view_31);
    view_4.fbb(p_29, view_29);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_32 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_32 = view_4.cbb_1;
  var p_32 = tmp0_elvis_lhs_32 == null ? view_4 : tmp0_elvis_lhs_32;
  view_4.ebb(p_32, view_32);
  view_32.xbm(true);
  view_32.zb8(get_px(0));
  forEach(view_32, pendingNonLinked, ($this$forEach, item) => {
    pendingRow($this$forEach, item);
    return Unit_instance;
  });
  view_4.fbb(p_32, view_32);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_33 = new (Space())(view_4.pc());
  var tmp0_elvis_lhs_33 = view_4.cbb_1;
  var p_33 = tmp0_elvis_lhs_33 == null ? view_4 : tmp0_elvis_lhs_33;
  view_4.ebb(p_33, view_33);
  view_4.fbb(p_33, view_33);
  if (lens.equals(ProjectLens_Customer_getInstance())) {
    var tmp_60 = get_atEnd(view_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_34 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_34 = view_4.cbb_1;
    var p_34 = tmp0_elvis_lhs_34 == null ? view_4 : tmp0_elvis_lhs_34;
    view_4.ebb(p_34, view_34);
    view_34.xbm(false);
    var labelValue = remember(VOID, VOID, VOID, ($this$remember) => {
      var selected = $this$remember.baj(selectedItems).p1();
      var pending_0 = $this$remember.baj(pending).p1();
      return selected >= pending_0 ? ' All' : selected <= 0 ? '' : ' (' + selected + ')';
    });
    var tmp_61 = get_primaryButton(view_34);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_35 = new (Button())(view_34.pc());
    var tmp0_elvis_lhs_35 = view_34.cbb_1;
    var p_35 = tmp0_elvis_lhs_35 == null ? view_34 : tmp0_elvis_lhs_35;
    view_34.ebb(p_35, view_35);
    var tmp_62 = KMutableProperty0();
    var tmp_63 = Button$_get_enabled_$ref_61t7nx_1(view_35);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('enabled', 0, tmp_62, tmp_63, Button$_set_enabled_$ref_o8kynz_1(view_35));
    reactiveScope(view_35, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$211 = !$this$reactiveScope.baj(selectedItems).i1();
      this_3.set(tmp$ret$211);
      return Unit_instance;
    });
    specCenteredText_0(view_35, ($this$specCenteredText) => 'Approve' + $this$specCenteredText.baj(labelValue));
    view_35.mbg(approveSelected(view_35, renderPendingChangeOrder$slambda_8(selectedItems, pending)));
    view_34.fbb(p_35, view_35);
    view_34.jbb(tmp_61, view_35);
    var tmp_64 = get_warningTextButton(view_34);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_36 = new (Button())(view_34.pc());
    var tmp0_elvis_lhs_36 = view_34.cbb_1;
    var p_36 = tmp0_elvis_lhs_36 == null ? view_34 : tmp0_elvis_lhs_36;
    view_34.ebb(p_36, view_36);
    var tmp_65 = KMutableProperty0();
    var tmp_66 = Button$_get_enabled_$ref_61t7nx_2(view_36);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_4 = getPropertyCallableRef('enabled', 0, tmp_65, tmp_66, Button$_set_enabled_$ref_o8kynz_2(view_36));
    reactiveScope(view_36, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$217 = !$this$reactiveScope.baj(selectedItems).i1();
      this_4.set(tmp$ret$217);
      return Unit_instance;
    });
    specCenteredText_0(view_36, ($this$specCenteredText) => 'Reject' + $this$specCenteredText.baj(labelValue));
    view_36.mbg(denySelected(view_36, renderPendingChangeOrder$slambda_10(selectedItems, pending)));
    view_34.fbb(p_36, view_36);
    view_34.jbb(tmp_64, view_36);
    view_4.fbb(p_34, view_34);
    view_4.jbb(tmp_60, view_34);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_37 = new (Space())(view_4.pc());
  var tmp0_elvis_lhs_37 = view_4.cbb_1;
  var p_37 = tmp0_elvis_lhs_37 == null ? view_4 : tmp0_elvis_lhs_37;
  view_4.ebb(p_37, view_37);
  view_4.fbb(p_37, view_37);
  view_3.fbb(p_4, view_4);
  view_3.jbb(tmp_10, view_4);
  view.fbb(p_3, view_3);
  var tmp$ret$238 = view.jbb(tmp_7, view_3);
  view.jbb(tmp_6, tmp$ret$238);
  greySeparator(view, ($this$greySeparator) => {
    var tmp = KMutableProperty0();
    var tmp_0 = Separator$_get_shown_$ref_e9a0og($this$greySeparator);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, Separator$_set_shown_$ref_f1kfq4($this$greySeparator));
    reactiveScope($this$greySeparator, ($this$reactiveScope) => {
      var tmp$ret$239 = !$this$reactiveScope.baj(expanded);
      this_0.set(tmp$ret$239);
      return Unit_instance;
    });
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
}
function renderPendingItems$_anonymous_$_anonymous_$_anonymous_$header_q4anrd($this_row, content) {
  var tmp = get_centered($this_row);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this_row.pc());
  var tmp0_elvis_lhs = $this_row.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this_row : tmp0_elvis_lhs;
  $this_row.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view.tb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = content;
  }
  tmp_0.fbu(tmp_1);
  $this_row.fbb(p, view);
  return $this_row.jbb(tmp, view);
}
function *_generator_renderPendingItems$_anonymous_$_anonymous_$_anonymous_$_anonymous_$selected__5rk4pk(selectedItems, $changeItems, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var tmp = await_0(selectedItems, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var selected = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var tmp_0 = await_1($changeItems, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (selected.t1(element.h40())) {
      destination.v(element);
    }
  }
  return destination;
}
function renderPendingItems$_anonymous_$_anonymous_$_anonymous_$_anonymous_$selected_k4i1gc(selectedItems, $changeItems, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_renderPendingItems$_anonymous_$_anonymous_$_anonymous_$_anonymous_$selected__5rk4pk.bind(VOID, selectedItems, $changeItems), $completion);
}
function renderPendingChangeOrder$_anonymous_$_anonymous_$tableRow_3w1ngh(_this__u8e3s4, weights, showLinked, id, submitted, showStatus, showOriginal, showTotal, showInfo) {
  _this__u8e3s4.zb8(weights.nha_1);
  var tmp = weight(_this__u8e3s4, weights.gha_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_0 = view.ibb(colored(view, AppColors_getInstance().dfz_1.xg9_1), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (IconView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = IconView$_get_visible_$ref_7ldslk(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('visible', 0, tmp_1, tmp_2, IconView$_set_visible_$ref_mp0dqc(view_0));
  var actionToCalculate = showInfo;
  reactiveScope(view_0, ($this$reactiveScope) => {
    this_0.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
  var tmp_3 = KMutableProperty0();
  var tmp_4 = IconView$_get_shown_$ref_js8irt(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, IconView$_set_shown_$ref_9ilxmr(view_0));
  var actionToCalculate_0 = showLinked;
  reactiveScope(view_0, ($this$reactiveScope) => {
    this_1.set(actionToCalculate_0($this$reactiveScope));
    return Unit_instance;
  });
  view_0.qbt(get_linked(Companion_getInstance_0()));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
  var tmp_5 = _this__u8e3s4.ibb(weight(_this__u8e3s4, weights.hha_1), get_centered(_this__u8e3s4));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
  _this__u8e3s4.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
  view_1.bbs(Align_Center_getInstance());
  var tmp_6 = KMutableProperty0();
  var tmp_7 = TextView$_get_visible_$ref_cygc3o_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('visible', 0, tmp_6, tmp_7, TextView$_set_visible_$ref_rs9jjk_0(view_1));
  var actionToCalculate_1 = showInfo;
  reactiveScope(view_1, ($this$reactiveScope) => {
    this_2.set(actionToCalculate_1($this$reactiveScope));
    return Unit_instance;
  });
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl_2(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_2(view_1));
  var actionToCalculate_2 = id;
  reactiveScope(view_1, ($this$reactiveScope) => {
    this_3.set(actionToCalculate_2($this$reactiveScope));
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p_1, view_1);
  _this__u8e3s4.jbb(tmp_5, view_1);
  var tmp_10 = weight(_this__u8e3s4, weights.iha_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_2 = _this__u8e3s4.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? _this__u8e3s4 : tmp0_elvis_lhs_2;
  _this__u8e3s4.ebb(p_2, view_2);
  view_2.jbb(get_centered(view_2), renderPriceChange(view_2, true, submitted));
  _this__u8e3s4.fbb(p_2, view_2);
  _this__u8e3s4.jbb(tmp_10, view_2);
  var tmp_11 = _this__u8e3s4.ibb(weight(_this__u8e3s4, weights.jha_1), get_centered(_this__u8e3s4));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_3 = _this__u8e3s4.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? _this__u8e3s4 : tmp0_elvis_lhs_3;
  _this__u8e3s4.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
  dynamicTheme(view_3, ($this$dynamicTheme) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (showStatus($this$dynamicTheme)) {
      tmp = ForegroundSemantic().agi(ChangeStatus_PendingApproval_getInstance().vh7_1);
    } else {
      tmp = null;
    }
    return tmp;
  });
  var tmp_12 = KMutableProperty0();
  var tmp_13 = TextView$_get_visible_$ref_cygc3o_1(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('visible', 0, tmp_12, tmp_13, TextView$_set_visible_$ref_rs9jjk_1(view_3));
  var actionToCalculate_3 = showInfo;
  reactiveScope(view_3, ($this$reactiveScope) => {
    this_4.set(actionToCalculate_3($this$reactiveScope));
    return Unit_instance;
  });
  view_3.bbs(Align_Center_getInstance());
  var tmp_14 = KMutableProperty0();
  var tmp_15 = TextView$_get_content_$ref_4pzcwl_3(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb_3(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (showStatus($this$reactiveScope)) {
      tmp = 'Pending';
    } else {
      tmp = '';
    }
    var tmp$ret$21 = tmp;
    this_5.set(tmp$ret$21);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p_3, view_3);
  _this__u8e3s4.jbb(tmp_11, view_3);
  var tmp_16 = _this__u8e3s4.ibb(weight(_this__u8e3s4, weights.kha_1), get_centered(_this__u8e3s4));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_4 = _this__u8e3s4.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? _this__u8e3s4 : tmp0_elvis_lhs_4;
  _this__u8e3s4.ebb(p_4, view_4);
  view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
  view_4.bbs(Align_Center_getInstance());
  var tmp_17 = KMutableProperty0();
  var tmp_18 = TextView$_get_visible_$ref_cygc3o_2(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_6 = getPropertyCallableRef('visible', 0, tmp_17, tmp_18, TextView$_set_visible_$ref_rs9jjk_2(view_4));
  var actionToCalculate_4 = showInfo;
  reactiveScope(view_4, ($this$reactiveScope) => {
    this_6.set(actionToCalculate_4($this$reactiveScope));
    return Unit_instance;
  });
  var tmp_19 = KMutableProperty0();
  var tmp_20 = TextView$_get_content_$ref_4pzcwl_4(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_7 = getPropertyCallableRef('content', 0, tmp_19, tmp_20, TextView$_set_content_$ref_pketfb_4(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (showOriginal($this$reactiveScope)) {
      tmp = '$0.00';
    } else {
      tmp = '';
    }
    var tmp$ret$30 = tmp;
    this_7.set(tmp$ret$30);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p_4, view_4);
  _this__u8e3s4.jbb(tmp_16, view_4);
  var tmp_21 = _this__u8e3s4.ibb(weight(_this__u8e3s4, weights.lha_1), get_centered(_this__u8e3s4));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_5 = _this__u8e3s4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? _this__u8e3s4 : tmp0_elvis_lhs_5;
  _this__u8e3s4.ebb(p_5, view_5);
  view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
  view_5.bbs(Align_Center_getInstance());
  var tmp_22 = KMutableProperty0();
  var tmp_23 = TextView$_get_visible_$ref_cygc3o_3(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_8 = getPropertyCallableRef('visible', 0, tmp_22, tmp_23, TextView$_set_visible_$ref_rs9jjk_3(view_5));
  var actionToCalculate_5 = showInfo;
  reactiveScope(view_5, ($this$reactiveScope) => {
    this_8.set(actionToCalculate_5($this$reactiveScope));
    return Unit_instance;
  });
  var tmp_24 = KMutableProperty0();
  var tmp_25 = TextView$_get_content_$ref_4pzcwl_5(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_9 = getPropertyCallableRef('content', 0, tmp_24, tmp_25, TextView$_set_content_$ref_pketfb_5(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (showTotal($this$reactiveScope)) {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp_0 = submitted($this$reactiveScope);
      var tmp0_elvis_lhs = tmp_0 == null ? null : tmp_0.a5s_1;
      var tmp_1;
      var tmp_2 = tmp0_elvis_lhs;
      if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
        tmp_1 = Companion_instance.p91(0n);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp = MonetaryValue__toString_impl_xslc77(tmp_1);
    } else {
      tmp = '';
    }
    var tmp$ret$40 = tmp;
    this_9.set(tmp$ret$40);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p_5, view_5);
  _this__u8e3s4.jbb(tmp_21, view_5);
}
function voidButton$lambda($this$shownWhen) {
  var tmp0_safe_receiver = $this$shownWhen.baj($this$shownWhen.baj(get_session()).pfw_1).m88_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var role = tmp;
  return role.d4(MemberRole_Manager_getInstance()) >= 0;
}
var voidButton$slambdaClass;
function voidButton$slambda() {
  if (voidButton$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.pha_1 = $item;
      }
      sao($completion) {
        return this.pha_1;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    voidButton$slambdaClass = $;
  }
  return voidButton$slambdaClass;
}
function voidButton$slambda_0($item) {
  var i = new (voidButton$slambda())($item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$withWrite, it, $completion) {
  if (it) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.rha_1;
    var tmp = await_1(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    // Inline function 'kotlin.collections.map' call
    var this_1 = tmp;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$1 = item.h40();
      destination.v(tmp$ret$1);
    }
    $this.qha_1.mam(toSet(destination));
  } else {
    $this.qha_1.mam(emptySet());
  }
  return Unit_instance;
}
var renderPendingItems$slambdaClass;
function renderPendingItems$slambda() {
  if (renderPendingItems$slambdaClass === VOID) {
    class $ {
      constructor($selectedItems, $changeItems) {
        this.qha_1 = $selectedItems;
        this.rha_1 = $changeItems;
      }
      afz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    renderPendingItems$slambdaClass = $;
  }
  return renderPendingItems$slambdaClass;
}
function renderPendingItems$slambda_0($selectedItems, $changeItems) {
  var i = new (renderPendingItems$slambda())($selectedItems, $changeItems);
  var l = ($this$withWrite, it, $completion) => i.afz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.sha_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var _iterator__ex2g4s = tmp.m1();
  while (_iterator__ex2g4s.n1()) {
    var change = _iterator__ex2g4s.o1();
    JumpTo_getInstance().mg3_1.xg4(change.q57_1, $this.tha_1);
  }
  return Unit_instance;
}
var renderPendingItems$slambdaClass_0;
function renderPendingItems$slambda_1() {
  if (renderPendingItems$slambdaClass_0 === VOID) {
    class $ {
      constructor($changeOrders, $$this$col) {
        this.sha_1 = $changeOrders;
        this.tha_1 = $$this$col;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingItems$slambdaClass_0 = $;
  }
  return renderPendingItems$slambdaClass_0;
}
function renderPendingItems$slambda_2($changeOrders, $$this$col) {
  var i = new (renderPendingItems$slambda_1())($changeOrders, $$this$col);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.hfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.uha_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.ff9(tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var renderPendingItems$slambdaClass_1;
function renderPendingItems$slambda_3() {
  if (renderPendingItems$slambdaClass_1 === VOID) {
    class $ {
      constructor($changeOrders) {
        this.uha_1 = $changeOrders;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingItems$slambdaClass_1 = $;
  }
  return renderPendingItems$slambdaClass_1;
}
function renderPendingItems$slambda_4($changeOrders) {
  var i = new (renderPendingItems$slambda_3())($changeOrders);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function renderPendingItems$lambda$lambda$lambda($this$actionIcon) {
  return ActionImportance_Important_getInstance();
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Checkbox$_get_visible_$ref_b1kh59(p0) {
  return () => p0.yb8();
}
function Checkbox$_set_visible_$ref_j8tp6n(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp = ChangeItemReadReceipts_instance.rh8($this.vha_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var update = tmp_0;
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance_1();
  var tmp$ret$0 = toDuration(5, DurationUnit_SECONDS_getInstance());
  var tmp_1 = delay(tmp$ret$0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  update();
  return Unit_instance;
}
var renderPendingItems$lambda$slambdaClass;
function renderPendingItems$lambda$slambda() {
  if (renderPendingItems$lambda$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.vha_1 = $item;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingItems$lambda$slambdaClass = $;
  }
  return renderPendingItems$lambda$slambdaClass;
}
function renderPendingItems$lambda$slambda_0($item) {
  var i = new (renderPendingItems$lambda$slambda())($item);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  var tmp = ChangeItemReadReceipts_instance.wh8($this.wha_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$Action, $completion) {
  var tmp = awaitOnce($this.xha_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var willExpand = !tmp;
  if (willExpand) {
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, renderPendingItems$lambda$slambda$slambda_0($this.yha_1));
  }
  $this.xha_1.mam(willExpand);
  return Unit_instance;
}
var renderPendingItems$lambda$slambda$slambdaClass;
function renderPendingItems$lambda$slambda$slambda() {
  if (renderPendingItems$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.wha_1 = $item;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingItems$lambda$slambda$slambdaClass = $;
  }
  return renderPendingItems$lambda$slambda$slambdaClass;
}
function renderPendingItems$lambda$slambda$slambda_0($item) {
  var i = new (renderPendingItems$lambda$slambda$slambda())($item);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var renderPendingItems$lambda$slambdaClass_0;
function renderPendingItems$lambda$slambda_1() {
  if (renderPendingItems$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($itemExpanded, $item) {
        this.xha_1 = $itemExpanded;
        this.yha_1 = $item;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingItems$lambda$slambdaClass_0 = $;
  }
  return renderPendingItems$lambda$slambdaClass_0;
}
function renderPendingItems$lambda$slambda_2($itemExpanded, $item) {
  var i = new (renderPendingItems$lambda$slambda_1())($itemExpanded, $item);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zha_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var selected = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ahb_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (selected.t1(element.h40())) {
      destination.v(element);
    }
  }
  return destination;
}
var renderPendingItems$slambdaClass_2;
function renderPendingItems$slambda_5() {
  if (renderPendingItems$slambdaClass_2 === VOID) {
    class $ {
      constructor($selectedItems, $changeItems) {
        this.zha_1 = $selectedItems;
        this.ahb_1 = $changeItems;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingItems$slambdaClass_2 = $;
  }
  return renderPendingItems$slambdaClass_2;
}
function renderPendingItems$slambda_6($selectedItems, $changeItems) {
  var i = new (renderPendingItems$slambda_5())($selectedItems, $changeItems);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var renderPendingItems$slambdaClass_3;
function renderPendingItems$slambda_7() {
  if (renderPendingItems$slambdaClass_3 === VOID) {
    class $ {
      constructor($selectedItems, $changeItems) {
        this.bhb_1 = $selectedItems;
        this.chb_1 = $changeItems;
      }
      sao($completion) {
        return renderPendingItems$_anonymous_$_anonymous_$_anonymous_$_anonymous_$selected_k4i1gc(this.bhb_1, this.chb_1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingItems$slambdaClass_3 = $;
  }
  return renderPendingItems$slambdaClass_3;
}
function renderPendingItems$slambda_8($selectedItems, $changeItems) {
  var i = new (renderPendingItems$slambda_7())($selectedItems, $changeItems);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $this$async, $completion) {
  var tmp = voidChangeItem($this.dhb_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$coroutineScope, $completion) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.ehb_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, renderPendingItems$slambda$slambda$slambda$slambda_0(item));
    destination.v(tmp$ret$0);
  }
  var tmp = awaitAll(destination, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var renderPendingItems$slambda$slambda$slambda$slambdaClass;
function renderPendingItems$slambda$slambda$slambda$slambda() {
  if (renderPendingItems$slambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.dhb_1 = $item;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingItems$slambda$slambda$slambda$slambdaClass = $;
  }
  return renderPendingItems$slambda$slambda$slambda$slambdaClass;
}
function renderPendingItems$slambda$slambda$slambda$slambda_0($item) {
  var i = new (renderPendingItems$slambda$slambda$slambda$slambda())($item);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = chunked($this.fhb_1, 10).m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = coroutineScope(renderPendingItems$slambda$slambda$slambda_0(element), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var tmp_0 = $this.ghb_1.gah(false, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var renderPendingItems$slambda$slambda$slambdaClass;
function renderPendingItems$slambda$slambda$slambda() {
  if (renderPendingItems$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($chunk) {
        this.ehb_1 = $chunk;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingItems$slambda$slambda$slambdaClass = $;
  }
  return renderPendingItems$slambda$slambda$slambdaClass;
}
function renderPendingItems$slambda$slambda$slambda_0($chunk) {
  var i = new (renderPendingItems$slambda$slambda$slambda())($chunk);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.hhb_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    var tmp_0 = renderPendingItems$_anonymous_$_anonymous_$_anonymous_$_anonymous_$selected_k4i1gc($this.ihb_1, $this.jhb_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var selected = tmp_0;
    var tmp_1 = 'Void ' + selected.p1() + ' Changes?';
    var tmp_2 = DangerButtonSemantic_getInstance();
    confirmationDialog($this.khb_1, tmp_1, "Voiding an item removes it from the client's consideration. This cannot be undone.", 'Void', VOID, tmp_2, VOID, VOID, VOID, VOID, renderPendingItems$slambda$slambda_0(selected, $this.hhb_1));
  } else {
    $this.khb_1.abb($this.lhb_1);
  }
  return Unit_instance;
}
var renderPendingItems$slambda$slambdaClass;
function renderPendingItems$slambda$slambda() {
  if (renderPendingItems$slambda$slambdaClass === VOID) {
    class $ {
      constructor($selected, $voiding) {
        this.fhb_1 = $selected;
        this.ghb_1 = $voiding;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingItems$slambda$slambdaClass = $;
  }
  return renderPendingItems$slambda$slambdaClass;
}
function renderPendingItems$slambda$slambda_0($selected, $voiding) {
  var i = new (renderPendingItems$slambda$slambda())($selected, $voiding);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var renderPendingItems$slambdaClass_4;
function renderPendingItems$slambda_9() {
  if (renderPendingItems$slambdaClass_4 === VOID) {
    class $ {
      constructor($voiding, $selectedItems, $changeItems, $$this$button, $deny) {
        this.hhb_1 = $voiding;
        this.ihb_1 = $selectedItems;
        this.jhb_1 = $changeItems;
        this.khb_1 = $$this$button;
        this.lhb_1 = $deny;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingItems$slambdaClass_4 = $;
  }
  return renderPendingItems$slambdaClass_4;
}
function renderPendingItems$slambda_10($voiding, $selectedItems, $changeItems, $$this$button, $deny) {
  var i = new (renderPendingItems$slambda_9())($voiding, $selectedItems, $changeItems, $$this$button, $deny);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, $this$withWrite, it, $completion) {
  if (it) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.mhb_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.nhb_1;
    var tmp_1 = await_1(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = tmp_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.s94()) {
        destination.v(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$5 = item.h40();
      destination_0.v(tmp$ret$5);
    }
    $this.mhb_1.mam(plus(tmp_0, toSet(destination_0)));
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.mhb_1;
    var tmp_2 = await_0(this_2, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = tmp_2;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.nhb_1;
    var tmp_4 = await_1(this_3, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = tmp_4;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().w();
    var _iterator__ex2g4s_1 = tmp0_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_0 = _iterator__ex2g4s_1.o1();
      if (element_0.s94()) {
        destination_1.v(element_0);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList().u(collectionSizeOrDefault(destination_1, 10));
    var _iterator__ex2g4s_2 = destination_1.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var item_0 = _iterator__ex2g4s_2.o1();
      var tmp$ret$13 = item_0.h40();
      destination_2.v(tmp$ret$13);
    }
    $this.mhb_1.mam(minus(tmp_3, toSet(destination_2)));
  }
  return Unit_instance;
}
var renderPendingChangeOrder$slambdaClass;
function renderPendingChangeOrder$slambda() {
  if (renderPendingChangeOrder$slambdaClass === VOID) {
    class $ {
      constructor($selectedItems, $pending) {
        this.mhb_1 = $selectedItems;
        this.nhb_1 = $pending;
      }
      afz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    renderPendingChangeOrder$slambdaClass = $;
  }
  return renderPendingChangeOrder$slambdaClass;
}
function renderPendingChangeOrder$slambda_0($selectedItems, $pending) {
  var i = new (renderPendingChangeOrder$slambda())($selectedItems, $pending);
  var l = ($this$withWrite, it, $completion) => i.afz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, $this$withWrite, it, $completion) {
  if (it) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.phb_1;
    var tmp = await_1(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    // Inline function 'kotlin.collections.map' call
    var this_1 = tmp;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$1 = item.h40();
      destination.v(tmp$ret$1);
    }
    $this.ohb_1.mam(toSet(destination));
  } else {
    $this.ohb_1.mam(emptySet());
  }
  return Unit_instance;
}
var renderPendingChangeOrder$slambdaClass_0;
function renderPendingChangeOrder$slambda_1() {
  if (renderPendingChangeOrder$slambdaClass_0 === VOID) {
    class $ {
      constructor($selectedItems, $pending) {
        this.ohb_1 = $selectedItems;
        this.phb_1 = $pending;
      }
      afz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    renderPendingChangeOrder$slambdaClass_0 = $;
  }
  return renderPendingChangeOrder$slambdaClass_0;
}
function renderPendingChangeOrder$slambda_2($selectedItems, $pending) {
  var i = new (renderPendingChangeOrder$slambda_1())($selectedItems, $pending);
  var l = ($this$withWrite, it, $completion) => i.afz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_12($this, $this$launch, $completion) {
  var tmp = JumpTo_getInstance().mg3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qhb_1;
  var tmp_0 = await_1(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.q57_1;
  tmp.xg4(tmp_1, $this.rhb_1, VOID, () => {
    $this.shb_1.mam(true);
    return Unit_instance;
  });
  return Unit_instance;
}
var renderPendingChangeOrder$slambdaClass_1;
function renderPendingChangeOrder$slambda_3() {
  if (renderPendingChangeOrder$slambdaClass_1 === VOID) {
    class $ {
      constructor($changeOrder, $$this$col, $expanded) {
        this.qhb_1 = $changeOrder;
        this.rhb_1 = $$this$col;
        this.shb_1 = $expanded;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingChangeOrder$slambdaClass_1 = $;
  }
  return renderPendingChangeOrder$slambdaClass_1;
}
function renderPendingChangeOrder$slambda_4($changeOrder, $$this$col, $expanded) {
  var i = new (renderPendingChangeOrder$slambda_3())($changeOrder, $$this$col, $expanded);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function renderPendingChangeOrder$lambda($this$actionIcon) {
  return ActionImportance_Important_getInstance();
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_13($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.hfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.thb_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = markAsRead(tmp_0, tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var renderPendingChangeOrder$slambda$slambdaClass;
function renderPendingChangeOrder$slambda$slambda() {
  if (renderPendingChangeOrder$slambda$slambdaClass === VOID) {
    class $ {
      constructor($changeOrder) {
        this.thb_1 = $changeOrder;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingChangeOrder$slambda$slambdaClass = $;
  }
  return renderPendingChangeOrder$slambda$slambdaClass;
}
function renderPendingChangeOrder$slambda$slambda_0($changeOrder) {
  var i = new (renderPendingChangeOrder$slambda$slambda())($changeOrder);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var renderPendingChangeOrder$slambdaClass_2;
function renderPendingChangeOrder$slambda_5() {
  if (renderPendingChangeOrder$slambdaClass_2 === VOID) {
    class $ {
      constructor($expanded, $changeOrder) {
        this.uhb_1 = $expanded;
        this.vhb_1 = $changeOrder;
      }
      sao($completion) {
        toggle(this.uhb_1);
        if (this.uhb_1.f2()) {
          var tmp = get_AppScope();
          launch(tmp, VOID, VOID, renderPendingChangeOrder$slambda$slambda_0(this.vhb_1));
        }
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingChangeOrder$slambdaClass_2 = $;
  }
  return renderPendingChangeOrder$slambdaClass_2;
}
function renderPendingChangeOrder$slambda_6($expanded, $changeOrder) {
  var i = new (renderPendingChangeOrder$slambda_5())($expanded, $changeOrder);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_visible_$ref_cygc3o(p0) {
  return () => p0.yb8();
}
function TextView$_set_visible_$ref_rs9jjk(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function renderPendingChangeOrder$lambda$lambda$lambda($this$tableRow) {
  return true;
}
function *_generator_invoke__zhh2q8_14($this, $this$launch, $completion) {
  var tmp = ChangeItemReadReceipts_instance.wh8($this.whb_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var renderPendingChangeOrder$lambda$slambdaClass;
function renderPendingChangeOrder$lambda$slambda() {
  if (renderPendingChangeOrder$lambda$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.whb_1 = $item;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderPendingChangeOrder$lambda$slambdaClass = $;
  }
  return renderPendingChangeOrder$lambda$slambdaClass;
}
function renderPendingChangeOrder$lambda$slambda_0($item) {
  var i = new (renderPendingChangeOrder$lambda$slambda())($item);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var renderPendingChangeOrder$lambda$slambdaClass_0;
function renderPendingChangeOrder$lambda$slambda_1() {
  if (renderPendingChangeOrder$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($item) {
        this.xhb_1 = $item;
      }
      sao($completion) {
        return ChangeItemReadReceipts_instance.rh8(this.xhb_1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingChangeOrder$lambda$slambdaClass_0 = $;
  }
  return renderPendingChangeOrder$lambda$slambdaClass_0;
}
function renderPendingChangeOrder$lambda$slambda_2($item) {
  var i = new (renderPendingChangeOrder$lambda$slambda_1())($item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function renderPendingChangeOrder$lambda_0($this$tableRow) {
  return false;
}
function renderPendingChangeOrder$lambda_1($this$tableRow) {
  return true;
}
function renderPendingChangeOrder$lambda_2($this$tableRow) {
  return false;
}
function renderPendingChangeOrder$lambda_3($this$tableRow) {
  return '';
}
function renderPendingChangeOrder$lambda_4($this$tableRow) {
  return false;
}
function renderPendingChangeOrder$lambda_5($this$tableRow) {
  return false;
}
function renderPendingChangeOrder$lambda_6($this$tableRow) {
  return false;
}
function renderPendingChangeOrder$lambda_7($this$tableRow) {
  return false;
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.yhb_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var selected = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.zhb_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (selected.t1(element.h40())) {
      destination.v(element);
    }
  }
  return destination;
}
var renderPendingChangeOrder$slambdaClass_3;
function renderPendingChangeOrder$slambda_7() {
  if (renderPendingChangeOrder$slambdaClass_3 === VOID) {
    class $ {
      constructor($selectedItems, $pending) {
        this.yhb_1 = $selectedItems;
        this.zhb_1 = $pending;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingChangeOrder$slambdaClass_3 = $;
  }
  return renderPendingChangeOrder$slambdaClass_3;
}
function renderPendingChangeOrder$slambda_8($selectedItems, $pending) {
  var i = new (renderPendingChangeOrder$slambda_7())($selectedItems, $pending);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ahc_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var selected = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.bhc_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (selected.t1(element.h40())) {
      destination.v(element);
    }
  }
  return destination;
}
var renderPendingChangeOrder$slambdaClass_4;
function renderPendingChangeOrder$slambda_9() {
  if (renderPendingChangeOrder$slambdaClass_4 === VOID) {
    class $ {
      constructor($selectedItems, $pending) {
        this.ahc_1 = $selectedItems;
        this.bhc_1 = $pending;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderPendingChangeOrder$slambdaClass_4 = $;
  }
  return renderPendingChangeOrder$slambdaClass_4;
}
function renderPendingChangeOrder$slambda_10($selectedItems, $pending) {
  var i = new (renderPendingChangeOrder$slambda_9())($selectedItems, $pending);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Separator$_get_shown_$ref_e9a0og(p0) {
  return () => p0.wb8();
}
function Separator$_set_shown_$ref_f1kfq4(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_visible_$ref_7ldslk(p0) {
  return () => p0.yb8();
}
function IconView$_set_visible_$ref_mp0dqc(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_shown_$ref_js8irt(p0) {
  return () => p0.wb8();
}
function IconView$_set_shown_$ref_9ilxmr(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_visible_$ref_cygc3o_0(p0) {
  return () => p0.yb8();
}
function TextView$_set_visible_$ref_rs9jjk_0(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_visible_$ref_cygc3o_1(p0) {
  return () => p0.yb8();
}
function TextView$_set_visible_$ref_rs9jjk_1(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_visible_$ref_cygc3o_2(p0) {
  return () => p0.yb8();
}
function TextView$_set_visible_$ref_rs9jjk_2(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_visible_$ref_cygc3o_3(p0) {
  return () => p0.yb8();
}
function TextView$_set_visible_$ref_rs9jjk_3(p0) {
  return (_this__u8e3s4) => {
    p0.xb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
//region block: exports
export {
  renderPendingChangeOrder as renderPendingChangeOrderafxvzeril7s1,
  renderPendingItems as renderPendingItemsjuqdkw9jhpkp,
};
//endregion

//# sourceMappingURL=pendingChangeOrder.mjs.map
